var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoan2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0H64C72.8366 0 80 7.16344 80 16V64C80 72.8366 72.8366 80 64 80H16C7.16344 80 0 72.8366 0 64V16Z",
    fill: "#FDF4DF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9609 22.4643C25.5629 22.0187 30.4425 19.5697 34.1306 16.9375H45.8729C49.561 19.5697 54.4406 22.0187 60.0426 22.4643V39.9741C60.0426 51.2722 48.5727 60.7659 40.0018 63.0625C31.4309 60.7659 19.9609 51.2722 19.9609 39.9742V22.4643ZM34.538 36.1933L38.3447 40L34.5379 43.8067C34.0803 44.2643 34.0803 45.0063 34.5379 45.4638C34.9955 45.9214 35.7375 45.9214 36.1951 45.4638L40.0018 41.6571L43.8085 45.4638C44.2661 45.9214 45.008 45.9214 45.4656 45.4638C45.9232 45.0063 45.9232 44.2643 45.4656 43.8067L41.6589 40L45.4656 36.1933C45.9232 35.7357 45.9232 34.9937 45.4656 34.5362C45.008 34.0786 44.2661 34.0786 43.8085 34.5362L40.0018 38.3429L36.1951 34.5362C35.7375 34.0786 34.9955 34.0786 34.5379 34.5362C34.0804 34.9938 34.0804 35.7357 34.538 36.1933ZM40.0018 28.1147C33.4377 28.1147 28.1164 33.4359 28.1164 40C28.1164 46.5641 33.4377 51.8853 40.0018 51.8853C46.5659 51.8853 51.8871 46.5641 51.8871 40C51.8871 33.4359 46.5659 28.1147 40.0018 28.1147Z",
    fill: "#D8A123"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoan2);
export default __webpack_public_path__ + "static/media/loan2.690f6067408c6972c8db585e672fe843.svg";
export { ForwardRef as ReactComponent };